// extracted by mini-css-extract-plugin
export default {"title":"body_title__oTp6G","infoWrapper":"body_infoWrapper__CYCVz","tip":"body_tip__XDOvB","info":"body_info__96nnE","content":"body_content__XTiyB"};